import { API } from "../../constants/api";
import useAuthAxios from "../../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";
import { matchesCurrency, matchesNetwork } from "../../utils/asset-config";

const useGetExWallet = (coin: string, network: string) => {
  const axiosInstance = useAuthAxios();

  const getWallet = async () => {
    const response = await axiosInstance.get(
      API.getCryptoWallet(coin?.toUpperCase())
    );
    return response.data.data.wallet;
  };

  const { data: walletAddresses } = useQuery({
    queryKey: ["get-wallet", coin],
    queryFn: getWallet,
    retry: 1,
    enabled: !!coin,
  });

  const getWalletAddress = () => {
    if (walletAddresses && coin && network) {
      const sellWallet = walletAddresses.find(
        (wallet: any) =>
          wallet.walletType === "SELL" &&
          matchesCurrency(wallet.currency, coin) &&
          matchesNetwork(wallet.network, network)
      );

      return sellWallet?.address || null;
    }
    return null;
  };

  return getWalletAddress();
};

export default useGetExWallet;
